module.exports = __webpack_public_path__ + "static/img/信息2.baf1994.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/信息2.png
// module id = ktWc
// module chunks = 1